export const VERIFICATION_STATUSES = {
  draft: {
    value: 'draft',
    label: 'Not Submitted',
    color: 'bg-neutral-200 text-gray-700',
    message:
      'Your shop verification is still a draft. Please complete your shop details, upload all required documents, and pay the verification fee to submit.',
  },
  submitted: {
    value: 'submitted',
    label: 'Awaiting Review',
    color: 'bg-yellow-100 text-yellow-800',
    message:
      "Thanks for submitting! We've received your details, documents, and payment. Sit tight—we'll begin reviewing your submission shortly.",
  },
  in_review: {
    value: 'in_review',
    label: 'In Review',
    color: 'bg-blue-100 text-blue-800',
    message:
      "Your verification is in review. Our team is checking your shop details, documents, and payment. We'll let you know as soon as there's an update.",
  },
  approved: {
    value: 'approved',
    label: 'Approved',
    color: 'bg-green-100 text-green-800',
    message:
      'Congratulations—your shop is now verified! You can proceed to all retailer features without restrictions.',
  },
  rejected: {
    value: 'rejected',
    label: 'Rejected',
    color: 'bg-red-100 text-red-800',
    message:
      "We're sorry, but your verification wasn't approved. Please review the feedback, update your details or documents, and resubmit for another review.",
  },
}
